/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppSuggestionQueryVariables = Types.Exact<{
  appName: Types.Scalars['String']['input'];
}>;

export type IAppSuggestionQuery = {
  __typename?: 'Query';
  appSuggestion: {
    __typename?: 'AppSuggestion';
    criticality: Types.AppCriticalityEnum;
    description: string;
    industry: string;
    jurisdiction: string;
    name: string;
    softwareType: string;
  };
};

export const AppSuggestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appSuggestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appSuggestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'industry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'softwareType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppSuggestionQuery, IAppSuggestionQueryVariables>;
